'use client';

import { api } from './api';
import { TRADE_SCALPER_DASHBOARD_STATE_KEY, useAuthStore } from './auth.store';
import { useAdminAuthStore } from './admin-auth.store';
import { disconnectSocket } from './socket';
import { ADMIN_LOGIN_PATH, isAdminPath } from './admin-paths';

export async function performClientLogout(redirectPath?: string): Promise<void> {
  const token = useAuthStore.getState().token || useAdminAuthStore.getState().token;
  const nextPath = typeof window !== 'undefined'
    ? redirectPath || (isAdminPath(window.location.pathname) ? ADMIN_LOGIN_PATH : '/login')
    : redirectPath;

  disconnectSocket();
  useAuthStore.getState().logout();
  useAdminAuthStore.getState().logout();

  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(TRADE_SCALPER_DASHBOARD_STATE_KEY);
    window.location.href = nextPath || '/login';
  }

  try {
    if (token) {
      await api.post('/auth/logout', undefined, { timeout: 1500 });
    }
  } catch {
    // Clear local auth state even when the server session is already invalid.
  }
}
